import RegisterPage from '@template/RegisterPage/RegisterPage'
import withPreventedRoute from 'hoc/with-prevented-route'

const Register = () => <RegisterPage />

export default withPreventedRoute(Register)
